import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { truncateFileName, getFileName, isCSV } from "src/utils/common";
import { SIMULATION_TYPE, EXECUTION_FILE_TYPE } from "src/constant/common";

const TabNavigation = ({
  fileData,
  serieData,
  activeTab,
  simulationType,
  executionFileName,
  isNewVersion,
  isHasExcelFiles,
  getTabId,
  onTabChange,
  t,
}) => {
  const renderNavItem = (tabName, displayName, index = null) => {
    const tabId = getTabId(tabName, index);
    if (!tabId) return null;

    return (
      <NavItem key={`${tabName}-${index || 0}`} className={`${activeTab === tabId ? "active" : ""}`}>
        <NavLink role="button" onClick={() => onTabChange(tabId)}>
          {displayName}
        </NavLink>
      </NavItem>
    );
  };

  const render6DOFTabs = () => {
    if (
      (simulationType !== SIMULATION_TYPE["6DOF"] && simulationType !== SIMULATION_TYPE["6DOF_MCS"]) ||
      (executionFileName !== EXECUTION_FILE_TYPE.MAIN_6DOF &&
        executionFileName !== EXECUTION_FILE_TYPE.MCS_6DOF &&
        executionFileName !== EXECUTION_FILE_TYPE.DISPERSION_6DOF &&
        executionFileName !== EXECUTION_FILE_TYPE.EXPECTED_CASUALTY_6DOF)
    ) {
      return null;
    }

    return (
      <>
        {fileData?.mass_shape_link && renderNavItem("mass_shape", truncateFileName(getFileName(fileData.mass_shape_name)))}
        {fileData?.wind_model_name && renderNavItem("wind_model", truncateFileName(fileData.wind_model_name))}
        {fileData?.target_attitude_rate_ascent_name &&
          renderNavItem("target_attitude_rate_ascent", truncateFileName(fileData.target_attitude_rate_ascent_name))}
        {fileData?.target_attitude_rate_descent_name &&
          renderNavItem("target_attitude_rate_descent", truncateFileName(fileData.target_attitude_rate_descent_name))}
        {fileData?.target_attitude_ascent_name &&
          renderNavItem("target_attitude_ascent", truncateFileName(fileData.target_attitude_ascent_name))}
        {fileData?.target_attitude_descent_name &&
          renderNavItem("target_attitude_descent", truncateFileName(fileData.target_attitude_descent_name))}
        {isHasExcelFiles(fileData) && renderNavItem("excel_files", t("new.input_excel_files"))}
      </>
    );
  };

  const render3DOFTabs = () => {
    if (simulationType !== SIMULATION_TYPE["3DOF"]) {
      return null;
    }

    return (
      <>
        {/* Aero files for new version */}
        {isNewVersion &&
          fileData?.aero_files &&
          Array.isArray(fileData.aero_files) &&
          fileData.aero_files
            .filter((aeroFile) => aeroFile?.aero_name && isCSV(aeroFile.aero_name))
            .map((aeroFile, index) => renderNavItem("aero_file", truncateFileName(aeroFile?.aero_name), index))}

        {/* Aero files for old version */}
        {!isNewVersion &&
          fileData?.aero1_name &&
          isCSV(fileData?.aero1_name) &&
          renderNavItem("aero1", truncateFileName(fileData?.aero1_name))}
        {!isNewVersion &&
          fileData?.aero2_name &&
          isCSV(fileData?.aero2_name) &&
          renderNavItem("aero2", truncateFileName(fileData?.aero2_name))}

        {fileData?.wind_model_name && renderNavItem("wind_model", truncateFileName(fileData?.wind_model_name))}
        {fileData?.thrust_profile_name && renderNavItem("thrust_profile", truncateFileName(fileData?.thrust_profile_name))}
        {isHasExcelFiles(fileData) && renderNavItem("excel_files", t("new.input_excel_files"))}
      </>
    );
  };

  return (
    <div className="nav-scroll-container">
      <Nav tabs className="border-0 flex-nowrap">
        {fileData && (
          <>
            {renderNavItem("main_file", truncateFileName(getFileName(fileData?.name)))}
            {serieData?.fileResponseLink && renderNavItem("series_response", truncateFileName(getFileName(serieData?.fileResponseName)))}
            {render6DOFTabs()}
            {render3DOFTabs()}
            {fileData?.jsonUpdateContent && renderNavItem("json_compare", "JSON Compare")}
          </>
        )}
      </Nav>
    </div>
  );
};

export default TabNavigation;
